export default __webpack_public_path__ + "static/media/swift.527c6f46.svg";